import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addTaskPriorities, updateTaskPriorities } from '../../actions/userActions/taskPriorityAction';
import { HexColorPicker } from 'react-colorful';
import '../dashboard/Dashboard.css';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea';
import priorityicon from "../../assets/images/priorityicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import TextField from '../designSystem/TextField';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
function AddTaskPriorities({ onClose, editData, onSave }) {
  const dispatch = useDispatch();
  const initialValues = { name: "", description: "", active: false, color: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'taskpriority');
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      if (editData) {
        await dispatch(updateTaskPriorities(formValues));
      } else {
        await dispatch(addTaskPriorities(formValues));
      }
      onSave(formValues);
    }
  };

  const handleColorChange = (color) => {
    setFormValues({ ...formValues, color: color });
  };
  const validateColor = (color) => {
    return /^#[0-9A-F]{6}$/i.test(color) ? color : "#ffffff";
  };

  return (
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container">
        <div className="dynamicmodal-header">
          <div className="dynamicmodal-header-left">
            <div className="icon">
              <img src={priorityicon} alt="priorityicon"a />
            </div>
            <div className="text">
              <h2 className="modalheading">
                {editData ? "Edit Task Priority" :  `${t("addTaskPriority")}`}
              </h2>
              <p className="modaldescription">
                {t("addTaskPriority")}
              </p>
            </div>
          </div>
          <div className="dynamicmodal-header-right">
            <IconButton onClick={onClose}>
              <img src={closeModal} alt="Close" />
            </IconButton>
          </div>
        </div>
        <form onSubmit={handleSave}>
          <div className="dynamicmodal-body" style={{ paddingTop: '20px', maxHeight: 'calc(80vh - 200px)', overflowY: 'auto', overflowX: 'hidden',paddingRight: '8px' }}>
            <TextField
              name="name"
              label={`${t("name")} *`}
              type="text"
              value={formValues.name}
              onChange={handleChange}
              placeholder={t("name")}
              error={formErrors.name}
            />
            <Textarea
              name="description"
              label={`${t("description")} *`}
              placeholder={t("description")}
              value={formValues.description}
              onChange={handleChange}
              error={formErrors.description}
            />
            <div className="col-md-12 mt-3">
              <label className="form-control-label">{`${t("color")} *`}</label>
              <HexColorPicker
                color={validateColor(formValues.color)}
                onChange={handleColorChange}
              />

              {formErrors.color && <div className='error-multi-select-container mt-2'>{formErrors.color}</div>}
            </div>
            <div className=" mt-2 ml-0">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                <input
                  name="active"
                  style={{ cursor: "pointer", height: "14px", width: "14px" }}
                  type="checkbox"
                  checked={formValues.active}
                  className="ml-1 mt-1"
                  onChange={handleChange}
                />
                <label
                  style={{ paddingLeft: "5px" }}
                  className="form-control-label"
                >
                  <div style={{ padding: '2px' }}>
                    <BodySmallMedium text={t("active")} color="#1E293B" />
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div className="dynamicmodal-footer">
            <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTaskPriorities;
